import { useEffect, useState } from "react";
import { getCoupons } from "../../api/user";
import "../../styles/profile.css";
import "../../styles/product_page.css";
export const CouponPage = () => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const data = await getCoupons();
                setCoupons(data);
            } catch (error) {
                console.error("Failed to fetch coupons:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCoupons();
    }, []);

    if (loading) {
        return (
            <div className="profile-scroll-container hide-scrollbar">
                <div className="profile-page">Loading coupons...</div>
            </div>
        );
    }

    return (
        <div className="profile-scroll-container hide-scrollbar">
            <div className="profile-page padding-top">
            <h1>Available coupons</h1>
            {coupons.length === 0 ? (
                <p>No coupons available.</p>
            ) : (
                <div>
                    {coupons.map((coupon) => (
                        <div key={coupon.code} className="coupon-preview">
                            <strong>{coupon.code}</strong> - {coupon.discount}% off
                            <br />
                            {coupon.description && <em>{coupon.description}</em>}
                        </div>
                    ))}
                </div>
            )}
        </div>
        </div>
    );
};
